import moment from 'moment';

export function makeInterval(target, remainingChanged) {
    return setInterval(() => {
        remainingChanged(getTimeUntilToStart(target))
    }, 1000)
}

function getTimeUntilToStart(target) {
    const now = moment()
    if (now.isAfter(moment(target))) {
        return null
    }
    const duration = moment.duration(moment(target).diff(now));
    const days = duration.asDays()
    const result = moment.duration(days, 'days').humanize()
    // result is '8 minut'
    return `${days > 1 ? result + ', ' : ''} ${moment.utc(duration.asMilliseconds()).format('HH:mm:ss')}`
}
//
// function getTimeUntilToEnd(target) {
//     const now = moment()
//     if (now.isAfter(moment(target))) {
//         return null
//     }
//     const duration = moment.duration(moment(target).diff(now));
//     const days = duration.asDays()
//     const result = moment.duration(days, 'days').humanize()
//     // result is '8 minut'
//     return `${moment.utc(duration.asMilliseconds()).format('HH:mm:ss')}`
// }
